// extracted by mini-css-extract-plugin
export default {"container":"reordableColumns_container__ShCaU","dragging_over":"reordableColumns_dragging_over__oG1M5","dragging":"reordableColumns_dragging__mHvYM"};